// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectToken, selectUser } from '../store/authSlice';
import { Box, Typography, CircularProgress } from '@mui/material';
import { Shield } from '@mui/icons-material';

export default function ProtectedRoute({ children }) {
  const token    = useSelector(selectToken);
  const user     = useSelector(selectUser);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check admin access via canAccessDasboard on the role object
  const isAdmin = user?.role?.canAccessDasboard === true;

  if (!isAdmin) {
    return (
      <Box sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        gap: 2,
      }}>
        <Shield sx={{ fontSize: 56, color: '#f44336', opacity: 0.7 }} />
        <Typography variant="h5" sx={{ color: '#e8f1fb', fontWeight: 600 }}>
          Access Denied
        </Typography>
        <Typography sx={{ color: '#7a9bbf' }}>
          You don't have admin privileges.
        </Typography>
      </Box>
    );
  }

  return children;
}
